import React, { FC, PropsWithChildren } from 'react';

import { CirclePlaceholder } from 'src/components/circle-placeholder';

import {
  StyledInformationStep,
  StyledIconContainer,
  StyledIconWrapper,
  StyledContent,
} from './base-information-step.styled';

export interface BaseInformationStepProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  loading?: boolean;
}

export const BaseInformationStep: FC<PropsWithChildren<BaseInformationStepProps>> = (props) => {
  const { icon: Icon, children, loading } = props;

  return (
    <StyledInformationStep>
      <StyledIconContainer $loading={loading}>
        {loading ? (
          <CirclePlaceholder />
        ) : (
          <StyledIconWrapper>
            <Icon width={32} height={32} />
          </StyledIconWrapper>
        )}
      </StyledIconContainer>
      <StyledContent>{children}</StyledContent>
    </StyledInformationStep>
  );
};
